import React from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "@/components/ui/Icon";
import { useUserRoles } from "@/hooks/useUserRoles";
import { NavModule, canSee, isNavPageActive } from "@/routes/navigation";
import styles from "./styles.module.scss";

interface SidebarProps {
  module: NavModule;
  onNavigate?: () => void;
  // Desktop: recolhido mostra só os ícones, na mesma posição de quando aberto.
  collapsed?: boolean;
}

// Menu lateral: mostra só as páginas do módulo atual.
const Sidebar: React.FC<SidebarProps> = ({ module, onNavigate, collapsed = false }) => {
  const { pathname } = useLocation();
  const { roles } = useUserRoles();
  const pages = module.pages.filter((page) => canSee(page.roles, roles));

  return (
    <nav aria-label={`Menu: ${module.title}`} className={`${styles.sidebar} ${collapsed ? styles.collapsed : ""}`}>
      <div className={styles.heading} aria-hidden={collapsed || undefined}>
        <span className={styles.kicker}>{module.kicker}</span>
        <span className={styles.title}>{module.title}</span>
      </div>
      <div className={styles.items}>
        {pages.map((page) => {
          const active = isNavPageActive(page, pathname);
          const className = [
            styles.item,
            page.icon ? "" : styles.sub,
            active ? (page.group && !collapsed ? styles.groupActive : styles.active) : "",
          ].join(" ");
          // Subpáginas (sem ícone) ficam invisíveis, mas guardam o espaço.
          const hidden = collapsed && !page.icon;

          return (
            <Link
              key={`${page.label}-${page.path}`}
              to={page.path}
              className={className}
              aria-current={active && !page.group ? "page" : undefined}
              aria-hidden={hidden || undefined}
              tabIndex={hidden ? -1 : undefined}
              title={collapsed ? page.label : undefined}
              onClick={onNavigate}
            >
              {page.icon && <Icon name={page.icon} size={18} strokeWidth={1.8} />}
              <span className={styles.label}>{page.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default Sidebar;
